export const LOGIN_PAGE_URL = "/login";
export const DASHBOARD_PAGE = {
    url: "/dashboard",
    title: "Dashboard",
};
export const FILES_PAGE = {
    url: "/files",
    title: "Files",
};
export const DATA_IMPORT_PAGE = {
    url: "/dataimport",
    title: "Data Import",
};
export const REPORTS_PAGE = {
    url: "/values",
    title: "Values",
};
export const DOCS_PAGE = {
    url: "/docs",
    title: "Docs",
};
export const SETTINGS_PAGE = {
    url: "/settings",
    title: "Settings",
};
export const INVITATIONS_PAGE = {
    url: "/invitations",
    title: "Invitations",
};
export const HELP_PAGE = {
    url: "/help",
    title: "Help",
};
export const ADMIN_PAGE = {
    url: "/admin",
    title: "Admin",
};
export const MPCWALLET_PAGE = {
    url: "/mpc",
    title: "MpcWallet",
};
export const FILEDETAIL_PAGE = {
    url: "/filedetailpage",
    title: "File Detail",
};
export const loggedInPages = [
    DASHBOARD_PAGE,
    FILES_PAGE,
    DATA_IMPORT_PAGE,
    REPORTS_PAGE,
    DOCS_PAGE,
    SETTINGS_PAGE,
    INVITATIONS_PAGE,
    HELP_PAGE,
    ADMIN_PAGE,
    MPCWALLET_PAGE,
    FILEDETAIL_PAGE,
];
